import Loadable from "react-loadable";
import { Navigate, Route, Routes } from "react-router-dom";
import Dashboard from "./modules/dashboard/dashboard";
import ErrorBoundaryRoutes from "./shared/error/error-boundary-routes";
import PrivateRoute from "./shared/private-route/private-route";
import { ESOBES_ENABLED } from "./modules/esobes/models";

const AppRoutes = () => {
  const loading = <div>loading ...</div>;

  const StudentModule = Loadable({
    loader: () => import("./modules/student"),
    loading: () => loading,
  });

    const StudentScholarshipModule = Loadable({
        loader: () => import("./modules/student-scholarship"),
        loading: () => loading,
    });

    const EpvoStudentModule = Loadable({
        loader: () => import("./modules/epvo-student"),
        loading: () => loading,
    });

    const KdpModule = Loadable({
        loader: () => import("./modules/kdp"),
        loading: () => loading,
    });

    const GbdflModule = Loadable({
        loader: () => import("./modules/gbdfl"),
        loading: () => loading,
    });

    const GbdulModule = Loadable({
        loader: () => import("./modules/gbdul"),
        loading: () => loading,
    });

    const UnemployedModule = Loadable({
        loader: () => import("./modules/unemployed"),
        loading: () => loading,
    });

    const EsobesModule = Loadable({
        loader: () => import("./modules/esobes"),
        loading: () => loading,
    });

    const NobdModule = Loadable({
        loader: () => import("./modules/nobd"),
        loading: () => loading,
    });

  const ReportModule = Loadable({
    loader: () => import("./modules/report"),
    loading: () => loading,
  });

    const UniversityModule = Loadable({
        loader: () => import("./modules/university"),
        loading: () => loading,
    });

    const UniversityResponsibleModule = Loadable({
        loader: () => import("./modules/university-responsible"),
        loading: () => loading,
    });
    const MessageModule = Loadable({
        loader: () => import("./modules/messages"),
        loading: () => loading,
    });

    const DictionariesModule = Loadable({
        loader: () => import("./modules/dictionaries"),
        loading: () => loading,
    });

    const ShepLogsModule = Loadable({
        loader: () => import("./modules/shep-logs"),
        loading: () => loading,
    });

    const IntegrationLogsModule = Loadable({
        loader: () => import("./modules/integration-logs"),
        loading: () => loading,
    });

    const ScholarshipCalculatorModule = Loadable({
        loader: () => import("./modules/scholarship-calculator"),
        loading: () => loading,
    });

  return (
    <ErrorBoundaryRoutes>
      <Route
        path="*"
        element={
          <Routes>
            <Route path="/" element={<Navigate to="/home" />} />
            <Route path="home" element={<Dashboard />} />
            <Route
              path="student/*"
              element={
                <PrivateRoute hasNoRoles={["ROLE_AUDIT"]}>
                  <StudentModule />
                </PrivateRoute>
              }
            />
            <Route
              path="student-scholarship/*"
              element={
                <PrivateRoute hasRoles={["ROLE_ACCOUNTANT"]}>
                  <StudentScholarshipModule />
                </PrivateRoute>
              }
            />
            <Route
              path="epvo-student/*"
              element={
                <PrivateRoute hasRoles={["ROLE_SYSTEM", "ROLE_ACCOUNTANT"]}>
                  <EpvoStudentModule />
                </PrivateRoute>
              }
            />
            <Route
              path="kdp/*"
              element={
                <PrivateRoute hasRoles={["ROLE_SYSTEM"]}>
                  <KdpModule />
                </PrivateRoute>
              }
            />
            <Route
              path="gbdfl/*"
              element={
                <PrivateRoute hasRoles={["ROLE_SYSTEM"]}>
                  <GbdflModule />
                </PrivateRoute>
              }
            />
            <Route
              path="gbdul/*"
              element={
                <PrivateRoute hasRoles={["ROLE_SYSTEM"]}>
                  <GbdulModule />
                </PrivateRoute>
              }
            />
            <Route
              path="unemployed/*"
              element={
                <PrivateRoute hasRoles={["ROLE_SYSTEM"]}>
                  <UnemployedModule />
                </PrivateRoute>
              }
            />
            {ESOBES_ENABLED && (
              <Route
                path="esobes/*"
                element={
                  <PrivateRoute hasNoRoles={["ROLE_AUDIT", "ROLE_DIRECTOR"]}>
                    <EsobesModule />
                  </PrivateRoute>
                }
              />
            )}
            <Route
              path="nobd/*"
              element={
                <PrivateRoute hasRoles={["ROLE_SYSTEM"]}>
                  <NobdModule />
                </PrivateRoute>
              }
            />
              <Route
                  path="report/*"
                  element={
                      <PrivateRoute hasNoRoles={["ROLE_AUDIT"]}>
                          <ReportModule/>
                      </PrivateRoute>
                  }
              />
            <Route
              path="university/*"
              element={
                <PrivateRoute hasNoRoles={["ROLE_ACCOUNTANT", "ROLE_AUDIT"]}>
                  <UniversityModule />
                </PrivateRoute>
              }
            />
              <Route
                  path="university-responsible/*"
                  element={
                      <PrivateRoute hasRoles={["ROLE_DEPARTMENT_HEAD", "ROLE_DEPUTY_DIRECTOR", "ROLE_SYSTEM"]}>
                          <UniversityResponsibleModule />
                      </PrivateRoute>
                  }
              />
            <Route
              path="dictionaries/*"
              element={
                <PrivateRoute>
                  <DictionariesModule />
                </PrivateRoute>
              }
            />
            <Route
              path="message/*"
              element={
                <PrivateRoute>
                  <MessageModule />
                </PrivateRoute>
              }
            />
            <Route
              path="shep-logs/*"
              element={
                <PrivateRoute hasNoRoles={["ROLE_ACCOUNTANT", "ROLE_AUDIT", "ROLE_DIRECTOR"]}>
                  <ShepLogsModule />
                </PrivateRoute>
              }
            />
            <Route
              path="integration-logs/*"
              element={
                <PrivateRoute hasRoles={["ROLE_SYSTEM"]}>
                  <IntegrationLogsModule />
                </PrivateRoute>
              }
            />
            <Route
              path="scholarship-calculator/*"
              element={
                <PrivateRoute hasNoRoles={["ROLE_AUDIT"]}>
                  <ScholarshipCalculatorModule />
                </PrivateRoute>
              }
            />
          </Routes>
        }
      />
    </ErrorBoundaryRoutes>
  );
};

export default AppRoutes;
